import { ValidationProps } from 'ui';
import { TextCollection, UserMessage } from 'app/types-shared';
import { DefaultContainerProps } from 'app/infrastructure/redux';
import { SimpleFormProps } from 'app/infrastructure/simple-form/types';
import { actionCreators } from './actions';
import { Messaging } from 'app/infrastructure/push/types';
import { MyNotificationTranslation } from 'app/area/user-profile/my-notifications/constants';

export interface MyNotificationsState {
  fetchingLoadPermission: boolean;
  fetchingLoadConsent: boolean;
  fetchingLoadConsents: boolean;
  fetchingDeleteConsent: boolean;
  fetchingVerifyCode: boolean;
  fetchingSaveSubscription: boolean;
  fetchingSubscribePush: boolean;
  validation?: ValidationProps[];
  permission?: ConsentPermission;
  consent?: Consent;
  consents: Consent[];
  texts?: TextCollection;
}

export interface ConsentPermission {
  sms: boolean;
  push: boolean;
  messages?: {
    userMessages: UserMessage[];
  };
}

export interface ActionPermission {
  edit?: boolean;
}

export interface ConfigurationAccess {
  push: boolean;
}

export interface Consent {
  id?: number;
  recipientId: number;
  type: ConsentType;
  value?: TokenValue;
}

export interface TokenValue {
  name: string;
  token: string;
}

export interface ConsentValue {
  value: TokenValue;
  verificationCode?: string;
  verificationMessage?: string;
  channel?: Channel;
}

export interface Channel {
  id?: number;
  recipientId: number;
  type: ConsentType;
}

export type Subscription = Channel & ConsentValue;

export enum ConsentType {
  sms = 1,
  push = 2
}

export enum NotificationPermissionType {
  NotSupported,
  Unknown,
  Denied,
  Granted
}

export type MyNotificationsContainerProps = MyNotificationsState & typeof actionCreators
  & DefaultContainerProps & SimpleFormProps;

export interface CheckConsent {
  id?: number;
  consents: Consent[];
  value: Messaging;
  onDone: (fmcToken: string) => void;
  translation: MyNotificationTranslation;
}
